export default __webpack_public_path__ + "static/media/los-angeles.1bdee0b1.png";